import Resource from './Resource';

export default class AnnouncementsLists extends Resource {
	constructor(options={}) {
		let {
			route = 'announcements',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
